
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {
  getCurrentSite,
  getCurrentUser,
  getCurrentMerchant,
  isAdminUser,
  isDemoUser
} from 'redux/modules/currentUser/selectors'
import {getConnectedIntegrations} from 'redux/modules/integrations/selectors'

const canUseDOM = !!(
  (typeof window !== 'undefined' &&
  window.document && window.document.createElement)
)

export const IntercomAPI = (...args) => {
  if (canUseDOM && window.Intercom) {
    window.Intercom.apply(null, args)
  }
}

const INTERCOM_APP_ID = __INTERCOM_APP_ID__

export class IntercomContainer extends React.Component {
  static propTypes = {
    appID: PropTypes.string,
    adminUser: PropTypes.bool
  }

  constructor(props) {
    super(props)

    this.mountIntercom(props.appID, this.getUserProps(props))
  }

  componentWillReceiveProps(nextProps) {
    const {adminUser} = nextProps

    if (!canUseDOM) return

    if (window.Intercom) {
      if (adminUser) return this.shutdownIntercom()

      const userProps = this.getUserProps(nextProps)
      window.intercomSettings = {...userProps, app_id: INTERCOM_APP_ID}
      window.Intercom('update', userProps)
    }
  }

  componentWillUnmount() {
    if (!canUseDOM || !window.Intercom) return false

    window.Intercom('shutdown')
    delete window.Intercom
    delete window.intercomSettings
  }

  render() {
    return this.props.children
  }

  getUserProps(props) {
    const {
      name,
      email,
      phone,
      // eslint-disable-next-line camelcase
      user_id,
      currency,
      domain,
      timezone,
      status,
      // eslint-disable-next-line camelcase
      created_at,
      active,
      paid,
      companies,
      trial
    } = props

    return {
      name,
      email,
      phone,
      user_id,
      currency,
      domain,
      timezone,
      status,
      created_at,
      active,
      companies,
      paid,
      trial
    }
  }

  mountIntercom(appID, userProps) {
    if (!appID || !canUseDOM) {
      return
    }

    if (!window.Intercom) {
      (function(w, d, id, s, x) {
        function i() {
          i.c(arguments)
        }
        i.q = []
        i.c = function(args) {
          i.q.push(args)
        }
        w.Intercom = i
        s = d.createElement('script')
        s.async = 1
        s.src = `https://widget.intercom.io/widget/${id}`
        x = d.getElementsByTagName('script')[0]
        x.parentNode.insertBefore(s, x)
      })(window, document, appID)
    }

    window.intercomSettings = {...userProps, app_id: appID}

    if (window.Intercom) {
      window.Intercom('boot', userProps)
    }
  }

  shutdownIntercom() {
    if (!window.Intercom) return null

    if (this.shutdownTimeout && this.shutdownInterval) return null

    this.shutdownTimeout = setTimeout(() => clearInterval(this.shutdownInterval), 30000)
    this.shutdownInterval = setInterval(() => {
      if (window.Intercom && window.Intercom.booted) {
        window.Intercom('shutdown')
        delete window.Intercom
        delete window.intercomSettings

        clearInterval(this.shutdownInterval)
        clearTimeout(this.shutdownTimeout)
      }
    }, 100)
  }
}

const mapStateToProps = state => {
  let currentUser = getCurrentUser(state) || {}
  let currentMerchant = getCurrentMerchant(state) || {}
  let currentSite = getCurrentSite(state) || {}
  const demoUser = isDemoUser(state)
  const adminUser = isAdminUser(state)

  if (demoUser) {
    currentUser = {}
    currentMerchant = {}
    currentSite = {}
  }

  const {phone, name, firstName, lastName, email, createdAt, id} = currentUser
  const {currency, domain, timezone} = currentSite
  const {id: merchantId, name: merchantName, active, paid, trial} = currentMerchant
  const activeStatus = active ? 'Active' : 'Inactive'
  const trialStatus = trial ? 'Trial' : 'Not Trial'
  const paidStatus = paid ? 'Paid' : 'Free'
  const status = demoUser ? null : `${activeStatus} - ${trialStatus} - ${paidStatus}`
  const connectedIntegrations = getConnectedIntegrations(state)
  const connectedIntegrationsObj = connectedIntegrations ? connectedIntegrations
    .reduce(
      (acc, channel) => ({...acc, [`${channel.serviceId}_connected`]: !!channel.connected}),
      {}
    ) : {}
  const connectedIntegrationsValues = Object.values(connectedIntegrationsObj)

  if (connectedIntegrationsValues.length) {
    connectedIntegrationsObj.has_integrations = !!connectedIntegrationsValues.filter(Boolean).length
  }

  return {
    appID: INTERCOM_APP_ID,
    name: name || (lastName ? (`${firstName} ${lastName}`) : firstName),
    email,
    phone,
    user_id: id,
    currency,
    domain,
    timezone,
    status,
    companies: merchantId && merchantName ? [{
      company_id: merchantId,
      name: merchantName,
      custom_attributes: {
        active,
        trial,
        paid,
        ...connectedIntegrationsObj
      }
    }] : null,
    created_at: createdAt ? Math.floor(new Date(createdAt).getTime() / 1000) : null,
    active,
    paid,
    trial,
    demoUser,
    adminUser
  }
}

export default connect(mapStateToProps)(IntercomContainer)



// WEBPACK FOOTER //
// ./client/containers/IntercomContainer/index.js